import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { Calendar } from "iconsax-react";
import { memo } from "react";
import { Trans, useTranslation } from "react-i18next";

import { formatPersianNumber } from "@/lib/format/persian";
import type { DashboardWelcomeHeaderProps } from "./DashboardWelcomeHeader.types";
import * as styles from "./DashboardWelcomeHeader.styles";

export type { DashboardWelcomeHeaderProps } from "./DashboardWelcomeHeader.types";

export const DashboardWelcomeHeader = memo(function DashboardWelcomeHeader({
  storeName,
  date,
  todaySales = 0,
  awaitingPayment = 0,
}: DashboardWelcomeHeaderProps) {
  const { t } = useTranslation("home");
  const theme = useTheme();

  return (
    <Box sx={styles.root}>
      <Box sx={styles.textBlock}>
        <Typography sx={styles.title}>
          {t("dashboard.welcome", { storeName: storeName ?? "…" })}
        </Typography>
        <Typography sx={styles.subtitle} component="span">
          <Trans
            i18nKey="dashboard.welcomeStats"
            values={{
              sales: formatPersianNumber(todaySales),
              awaiting: formatPersianNumber(awaitingPayment),
            }}
            components={{
              sales: <Box component="span" sx={styles.statHighlight} />,
              awaiting: <Box component="span" sx={styles.statWarning} />,
            }}
          />
        </Typography>
      </Box>

      <Box sx={styles.datePill}>
        <Calendar size={16} variant="Linear" color={theme.palette.text.secondary} />
        <Typography component="span" variant="body2">
          {date}
        </Typography>
      </Box>
    </Box>
  );
});
